import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(dynamic)/trademark-renewal/[jurisdiction]/TrademarkRenewalJurisdiction.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
